import { render, staticRenderFns } from "./ArchitecturesList.vue?vue&type=template&id=1846aa71&"
import script from "./ArchitecturesList.vue?vue&type=script&lang=js&"
export * from "./ArchitecturesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1846aa71')) {
      api.createRecord('1846aa71', component.options)
    } else {
      api.reload('1846aa71', component.options)
    }
    module.hot.accept("./ArchitecturesList.vue?vue&type=template&id=1846aa71&", function () {
      api.rerender('1846aa71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/launchService/ArchitecturesList.vue"
export default component.exports